import { useAiSummaryFlusher } from '../../hooks/useAiSummaryFlusher';

// Headless, mounted once app-wide (App.tsx). Persists the batch AI summary to
// its threat once the "created" WebSocket event arrives - works regardless of
// which page created the threat (dashboard bulk add, FN bulk confirm).
export default function AiSummaryFlusher(): null {
  useAiSummaryFlusher();
  return null;
}
